import React from 'react'

const ScreenLoader = () => {
    return (
        <>
            <main className='d-flex justify-content-center align-items-center' style={{ height: '100vh', backgroundColor: "black" }} >
                <span className="loader"></span>
            </main>
        </>
    )
}

export default ScreenLoader